import React from "react";

const copy = {
  "brand-concepts": {
    title: "Brand concepts",
    body: "This category is ready for case studies and boards. Add projects in visualDevelopmentManifest.json and assets under public/Visual_Development/Brand Concepts.",
  },
  "campaign-key-visuals": {
    title: "Campaign key visuals",
    body: "Add entries to src/data/visualDevelopmentManifest.json and place imagery under public/Visual_Development/Campaign Key visuals to populate this grid.",
  },
};

const VisualDevEmptyState = ({ categoryId }) => {
  const { title, body } = copy[categoryId] ?? copy["campaign-key-visuals"];

  return (
    <div className="max-w-xl mx-auto px-6 py-20 md:py-24 text-center border border-white/[0.08] bg-white/[0.02]">
      <p className="text-[10px] font-semibold uppercase tracking-[0.3em] text-[#ffab3e]/90 mb-4">
        {title}
      </p>
      <p className="text-sm text-gray-500 leading-relaxed font-light">{body}</p>
    </div>
  );
};

export default VisualDevEmptyState;
